import { CountryCodes } from '@/enums/general'

export const SizechartZones = Object.freeze({
  eu: 'EU',
  uk: 'UK',
  fr: 'FR'
})

export const SizechartZonesCountryMap = Object.freeze({
  [CountryCodes.austria]: SizechartZones.eu,
  [CountryCodes.belgium]: SizechartZones.eu,
  [CountryCodes.denmark]: SizechartZones.eu,
  [CountryCodes.germany]: SizechartZones.eu,
  [CountryCodes.spain]: SizechartZones.eu,
  [CountryCodes.france]: SizechartZones.fr,
  [CountryCodes.netherlands]: SizechartZones.eu,
  [CountryCodes.unitedKingdom]: SizechartZones.uk,
  [CountryCodes.sweden]: SizechartZones.eu,
  [CountryCodes.italy]: SizechartZones.eu,
  [CountryCodes.poland]: SizechartZones.eu,
  [CountryCodes.switzerland]: SizechartZones.eu,
  [CountryCodes.ireland]: SizechartZones.uk,
  [CountryCodes.luxembourg]: SizechartZones.eu,
  [CountryCodes.portugal]: SizechartZones.eu,
  [CountryCodes.finland]: SizechartZones.eu,
  [CountryCodes.norway]: SizechartZones.eu,
  [CountryCodes.czechRepublic]: SizechartZones.eu
})
